import { render, staticRenderFns } from "./myAssess.vue?vue&type=template&id=772008bb&scoped=true&"
import script from "./myAssess.vue?vue&type=script&lang=js&"
export * from "./myAssess.vue?vue&type=script&lang=js&"
import style0 from "./myAssess.vue?vue&type=style&index=0&id=772008bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772008bb",
  null
  
)

export default component.exports